import styled from 'styled-components';
import TickIconSvg from '../assets/hotels/review/tick.svg';

const TickIcon = styled(TickIconSvg as JSX.Element)(
  props => `

    fill: ${props.theme.colors.downriver.medium};
`,
);

export default TickIcon;
